import { useEffect, useRef } from "react";
import ThemePlaceholder from "./ThemePlaceholder";
import { Input } from "reactstrap";

const pad2 = n => String(n).padStart(2, "0");

const formatTimeValue = value => {
  if (value == null || value === "") return value;
  if (value instanceof Date && !isNaN(value)) {
    return `${pad2(value.getHours())}:${pad2(value.getMinutes())}`;
  }
  if (typeof value === "string" && /^\d{1,2}:\d{2}(:\d{2})?$/.test(value)) {
    return value.slice(0, 5);
  }
  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
  }
  return value;
};

const formatDateValue = value => {
  if (value == null || value === "") return value;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  }
  return value;
};

const formatDateTimeLocalValue = value => {
  if (value == null || value === "") return value;
  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
  }
  return value;
};

export default function InputField({
  loading = false,
  children,
  type = "text",
  value,
  onChange,
  onBlur,
  invalid,
  ...props
}) {
  const textareaRef = useRef(null);

  const resizeTextarea = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    if (type === "textarea") {
      resizeTextarea();
    }
  }, [value, type]);

  let displayValue = value;
  if (type === "time") displayValue = formatTimeValue(value);
  else if (type === "date") displayValue = formatDateValue(value);
  else if (type === "datetime-local") displayValue = formatDateTimeLocalValue(value);

  if (loading) {
    return (
      <ThemePlaceholder
        style={{ height: type === "textarea" ? 80 : 30 }}
        className="mb-2"
      />
    );
  }

  return (
    <Input
      {...props}
      type={type}
      value={displayValue ?? ""}
      innerRef={type === "textarea" ? textareaRef : null}
      onInput={type === "textarea" ? resizeTextarea : props.onInput}
      onChange={onChange}
      onBlur={onBlur}
      invalid={invalid}
      style={type === "textarea" ? { overflow: "hidden", resize: "none" } : {}}
    >
      {children}
    </Input>
  );
}
